import { render, staticRenderFns } from "./WhatsAppTab.vue?vue&type=template&id=0e982dfe&scoped=true"
import script from "./WhatsAppTab.vue?vue&type=script&lang=js"
export * from "./WhatsAppTab.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppTab.vue?vue&type=style&index=0&id=0e982dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e982dfe",
  null
  
)

export default component.exports